import { render, staticRenderFns } from "./FeekBack.vue?vue&type=template&id=c8659136"
import script from "./FeekBack.vue?vue&type=script&lang=js"
export * from "./FeekBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports